
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"65","height":"63"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#0a294a","stroke-miterlimit":"20","stroke-width":"3","d":"M32.387 2.08v0L56.7 13.827v0l6.005 26.395v0L45.88 61.39v0H18.895v0L2.07 40.222v0l6.004-26.395v0z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M42.583 23.012c-1.08-1.23-2.622-2.013-4.327-2.041-3.274-.054-5.928 2.712-5.928 6.179 0 .492.052.971.154 1.433-4.928-.32-9.296-2.886-12.22-6.753A6.553 6.553 0 0019.46 25c0 2.196 1.046 4.146 2.637 5.297a5.676 5.676 0 01-2.685-.82v.08c0 3.067 2.043 5.64 4.755 6.24a5.581 5.581 0 01-2.677.09c.754 2.515 2.944 4.352 5.538 4.412-2.029 1.685-4.585 2.687-7.362 2.682a11.4 11.4 0 01-1.415-.091c2.623 1.8 5.74 2.848 9.087 2.848 10.906.003 16.868-9.486 16.868-17.717 0-.27-.005-.54-.016-.807a12.2 12.2 0 002.958-3.18c-1.064.48-2.206.797-3.405.93a6.078 6.078 0 002.606-3.404 11.38 11.38 0 01-3.765 1.452"}})])
          )
        }
      }
    